<template>
  <div class="animated fadeIn">
    <div>
      <b-modal v-model="showModal" hide-footer>
        O Sticker foi solicitado. Por favor, não solicite outro Sticker até que nossa equipe tenha entrado em contato.
        <b-row>
          <b-col>
            <b-button class="mt-3 bg-success" block @click="showModal = false">Entendi!</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <br />
    <div class="row">
      <b-col sm="6" offset-sm="3">
        <p>Qual frase você quer no Sticker?</p>
        <b-form-input v-model="stickerText" placeholder="Ex: Orgulho da Nutri"></b-form-input>
        <br/>
        <p>Qual tipo de Sticker você quer?</p>
        <b-form-select v-model="stickerType" placeholder="asasa" :options="[{value: 'ilustracao', text:'Ilustração'}, {value: 'foto', text:'Foto'}]"></b-form-select>
        <b-button variant="primary" style="margin-top: 30px;" @click="handleClick()">Solicitar Sticker</b-button>
      </b-col>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";
import { isIOS } from "mobile-device-detect";


export default {
  name: 'FreePassHome',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      showModal: false,
      isIOS: isIOS,
      stickerType: 'foto',
      stickerText: ''
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    }
  },
  methods: {
    handleClick() {
      service.requestSleeker("O cliente " + this.me.email + " solicitou um Sticker com a frase " + this.stickerText + " do tipo " + this.stickerType).then(() => {
        this.showModal = true;
      }).catch((error) => {
        this.openingTicket = false;
        if (error && error.message) {
          this.errorMessage = error.message;
        } else {
          this.errorMessage = "Ocorreu um erro inesperado ao criar o ticket. Por favor, entre em contato por outra forma de suporte.";
        }
      });
      
    },
    appBannerAction() {
      let url = "https://play.google.com/store/apps/details?id=pt.sleeker.androidapp";

      if (this.isIOS) {
        url = "https://apps.apple.com/us/app/sleeker/id1515716574"
      }

      window.open(url, "_blank");
    },
    bannerAction() {
      if (this.banner.destinationType == 0) {
        this.$router.push(this.banner.destination);
      } else {
        window.open(this.banner.destination, "_blank");
      }
    }
  },
  created() {
    service.getBanner().then(result => {
      this.banner = result.banner
      console.log(this.banner);
    });
    
    service.getMe().then(me => {
      this.me = me;
    })
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
